const updateStoreReviews = () => {
  // 1. Actualizar las estrellas dinámicas en la colección y en la cabecera del producto
  document.querySelectorAll('[data-product-id]').forEach(badge => {
    const idStr = badge.getAttribute('data-product-id');
    if (!idStr || idStr.includes('{{')) return; // Evita errores si no ha cargado el ID

    const id = Number(idStr) || 0;

    // Cálculo dinámico de valoraciones
    const starsDecimal = 4.0 + ((id % 100) / 100);
    const random = id % 3;
    const starsForDisplay = random === 0 ? 4.0 : random === 1 ? 4.5 : 5.0;
    const starsWhole = Math.floor(starsForDisplay);
    const hasHalf = starsForDisplay % 1 !== 0;
    const reviewCount = ((id % 251) + 50);

    // Renderizar las estrellas
    const starsContainer = badge.querySelector('.er-stars');
    if (starsContainer) {
      starsContainer.innerHTML = '';
      for (let i = 1; i <= 5; i++) {
        const star = document.createElement('span');
        star.className = 'er-preview-star';
        if (i <= starsWhole) {
          star.classList.add('er-preview-star--filled');
        } else if (i === starsWhole + 1 && hasHalf) {
          star.classList.add('er-preview-star--half');
        }
        star.textContent = '★';
        starsContainer.appendChild(star);
      }
    }

    // Actualizar texto en la página de producto (debajo del título)
    const textContainer = badge.querySelector('.er-rating-text');
    if (textContainer) {
      textContainer.textContent = `${starsDecimal.toFixed(1).replace('.', ',')} de 5 · ${reviewCount} avaliações`;
    }

    // Actualizar contador en las tarjetas de la página de colección
    const countContainer = badge.querySelector('.lr-grid-stars__count');
    if (countContainer) {
      countContainer.textContent = `(${reviewCount})`;
    }
  });

  // 2. Actualizar el resumen general justo encima de las reseñas escritas
  const productBadge = document.querySelector('.er-rating-badge[data-product-id]');
  if (productBadge) {
    const id = Number(productBadge.getAttribute('data-product-id')) || 0;
    const starsDecimal = 4.0 + ((id % 100) / 100);
    const reviewCount = ((id % 251) + 50);
    
    document.querySelectorAll('.er-reviews-summary').forEach(summary => {
      summary.textContent = `Avaliado ${starsDecimal.toFixed(1).replace('.', ',')} / 5 com base em ${reviewCount} avaliações verificadas`;
    });
  }
};

// Ejecutar cuando cargue la página
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateStoreReviews);
} else {
  updateStoreReviews();
}

// Mantener compatibilidad con el editor de temas de Shopify
document.addEventListener('shopify:section:load', updateStoreReviews);

// Observador para asegurar que las estrellas cargan si usas filtros dinámicos o scroll infinito en colecciones
new MutationObserver(records => {
  if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('[data-product-id]') || node.querySelector?.('[data-product-id]'))))) {
    updateStoreReviews();
  }
}).observe(document.documentElement, { childList: true, subtree: true });